import { render } from "./ProSpaceUserProfileModal.vue?vue&type=template&id=554a8f0f&scoped=true"
import script from "./ProSpaceUserProfileModal.vue?vue&type=script&lang=js"
export * from "./ProSpaceUserProfileModal.vue?vue&type=script&lang=js"

import "./ProSpaceUserProfileModal.vue?vue&type=style&index=0&id=554a8f0f&lang=scss"
import "./ProSpaceUserProfileModal.vue?vue&type=style&index=1&id=554a8f0f&lang=scss"
import "./ProSpaceUserProfileModal.vue?vue&type=style&index=2&id=554a8f0f&lang=scss&scoped=true"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554a8f0f"]])

export default __exports__